import { useTranslation } from 'react-i18next';

import { i18nNS } from '../../../../../../../i18n';
import TileDrawerHeaderLayout from '../../../../../../shared/TileDrawerHeaderLayout';
import PieChartIcon from '../../../../../../../icons/PieChartIcon';
import BarGraphIcon from '../../../../../../../icons/BarGraphIcon';
import { useParams } from 'react-router-dom';
import { PollParams } from '../../../../../../../routes/router';
import { enumFromStringValue } from '../../../../../../../utils/string';
import { PollSlideTypes } from '../../../../../../../db/types';
import { useMemo } from 'react';

const DrawerHeader = () => {
  const { t } = useTranslation([i18nNS.GLOSSARY]);

  const { slideType: slideTypeValues } = useParams<PollParams>();
  const slideType = enumFromStringValue(PollSlideTypes, slideTypeValues);

  const icon = useMemo(() => {
    switch (slideType) {
      case PollSlideTypes.BAR_GRAPH:
        return BarGraphIcon;
      case PollSlideTypes.PIE_CHART:
        return PieChartIcon;
      default:
        return BarGraphIcon;
    }
  }, [slideType]);

  return <TileDrawerHeaderLayout icon={icon}>{t('copy', { ns: i18nNS.GLOSSARY })}</TileDrawerHeaderLayout>;
};

export default DrawerHeader;
